define('views/pages/ReorderPageView',['underscore', 'backbone', 'jquery', 'app', 'PageView',
    'SelectView',
    'models/CartModel',
    'TagCommander',
    'template!reorder',
    'template!blocks/cart/reorder-delivery-options',
    'views/ui/ProductLineView',
    'InternalLinkView',
    'AddressAutocompleteView',
    'views/blocks/DateTimeSelectorView',
    'views/blocks/CartVoucherView',
    'views/blocks/AuthentificationView',
    'models/OrderModel'
], function (_, Backbone, $, app, PageView,
    SelectView,
    CartModel,
    TagCommander,
    reorderTemplate,
    reorderDeliveryOptions,
    ProductLineView,
    InternalLinkView,
    AddressAutocompleteView,
    DateTimeSelectorView,
    CartVoucherView,
    AuthentificationView,
    OrderModel
) {

    //
    // Vue de la modal "Repasser une commande"
    //

    // la vue est instanciée une seule fois en même temps.
    // on peut donc avoir des références unique pour le module,
    // qui seront détruite lors de la destruction de la PageView
    var view,
        customer,
        ordersList,
        virtualCart,
        parentOrder,
        CartModelConstructor,
        ReorderTranslationContext = 'Reorder';

    var ReorderPageView = PageView.extend({

        pageName: 'ReorderPage',
        displayAsModal: true,
        events: {
            'click .btn-close': 'clickClose',
            'change select.order-selector': 'orderChange',

            'click .addToCart': 'addtoCart',
            'click .btn-set-datetime': 'openDateTimeSelector',
            'click .btn-set-delivery-option': 'openAddressAutocomplete',
            'click .submit-reorder': 'setCurrentCart',
        },

        initialize: function () {

            view = this;
            // PageView constructor heritage
            PageView.prototype.initialize.apply(this, arguments);
            //
            // on instancie un panier virtuel
            CartModelConstructor = CartModel.getConstructor();
            virtualCart = new CartModelConstructor({id_cart: 'virtual'});
            view.attachCart(virtualCart);
            //
            view.setup();


        },
        setup:function(){
            customer = app.getCustomer();

            parentOrder = false;
            //virtualCart.save();

            var view = this,
                ordersHistory = customer.getAllOrders();
            ordersList = ordersHistory ? ordersHistory.clone() : false;

            if(!ordersHistory){
                customer.loadAllOrders().once('sync',view.setup,view);
            } else if (ordersList.size() > 0) {

                // il y a des commandes
                view.renderLoading();
                parentOrder = false;
                ordersList.setComparatorReorder();
                ordersList.each(function(order){
                   // if(order.isNowService() && !parentOrder ) {
                        parentOrder = order;
                        return true;
                    //}
                });
                if (parentOrder != false){
                    virtualCart.reorder(parentOrder.get('id_cart'));
                }else{
                   // il n'y a pas de commande
                   view.render();
                }
            }else{
                // il n'y a pas de commande
                view.render();
            }
        },
        attachCart:function(cart){
            virtualCart = cart;
            view.listenTo(virtualCart,'reorder',view.orderSync);
            view.listenTo(virtualCart,'setCurrent',view.onSetCurrent);
            view.listenTo(virtualCart,'deliveryUpdate',view.onDeliveryUpdate);
            view.listenTo(virtualCart,'addToCartReorder',view.onAddToCart);
        },
        renderLoading:function(){
            // effectue le rendu de préchargement
            view.$el.html('<button class="btn-close"><span></span><span></span></button><div class="reoder loader"></div>');
        },
        render: function () {

            var failMessage = 'La commande selectionnée ne peut être repassée %s',
                failMessageCause = '',
                productsIndispoSize = virtualCart.getProductsIndispo().size(),
                productsSize = virtualCart.getProducts().size(),
                unavailableProducts = 0,
                unavailableProductMessage = '';

            if(productsSize > 0 && productsIndispoSize > 0 && virtualCart.getPriceTTC() > 0){
                //
                // si certains produits sont indisponibles, mais que d'autres reste disponible, on informe l'utilisateur
                // sans bloquer le processus de commande
                //
                unavailableProducts = productsIndispoSize;
                unavailableProductMessage = (unavailableProducts > 1 ?
                    '%s produits de la commande selectionnée ne sont aujourd’hui plus disponibles.':
                     'Un des produits de la commande selectionnée n’est aujourd’hui plus disponible.');
            }

            if((!virtualCart.isVAE()) && _.isUndefined(virtualCart.getAddressDelivery())){
                //
                // si l'adresse n'est pas disponible
                //
                virtualCart.set('reorderFail','unavailableAddress');
            }

            if(!(virtualCart.getPriceTTC() > 0 && productsSize > 0)){
                //
                // si le prix est nul ou qu'il n'y a pas de produit
                //
                virtualCart.set('reorderFail','emptyCart');
            }

            switch(virtualCart.get('reorderFail')){
                case undefined : // do nothing
                    break;
                case 'unavailableAddress' :
                    failMessageCause = 'car l’adresse a été supprimée de votre compte. Vous pouvez cependant ajouter les produits à votre panier et continuer votre commande.';
                    break;
                case 'emptyCart' :
                    failMessageCause = 'car les produits associés ne sont aujourd’hui plus disponibles.';
                    break;
                // case 'unavailableProducts' :
                //     failMessageCause = 'car certains produits sont actuellement indisponibles.';
                //     break;
                // erreur inconnue
                default :
                    virtualCart.set('reorderFail','unkwown');
                case 'unkwown':
                    failMessageCause = 'en raison d’une erreur technique. Veuillez nous excuser pour le désagrément.';
            }

            failMessage = app.t(failMessage,ReorderTranslationContext, app.t(failMessageCause,ReorderTranslationContext));


            view.$el.html(reorderTemplate({
                customer: customer,
                cart: virtualCart,
                reorderFail: virtualCart.get('reorderFail'),
                unavailableProducts: unavailableProducts,
                unavailableProductMessage: unavailableProductMessage,
                failMessage: failMessage,
                store: virtualCart.getStore(),
                ordersList: ordersList,
                parentOrder:parentOrder,
            }));

            if(!customer.isLogged()){
                view.listenToOnce(customer,"login logout", view.authentificationSuccess);
                //
                var blockAuthentification = view.appendView(AuthentificationView,'.authentification-block',{register: false, newsletter:false});
                  view.listenTo(blockAuthentification, 'success', view.authentificationSuccess);
                  blockAuthentification.render();

            }else if(parentOrder){
                view.attachViews(ProductLineView.initializeProductLinesOfView(view));

                function AppendView(constructor,selector,options){
                    view.appendView(constructor,selector,options);
                }


                AppendView(CartVoucherView,'.cart-voucher',{origin: 'reorder', cart:virtualCart});


            }

            InternalLinkView.initializeLinksOfView(view);
            view.attachViews(SelectView.initializeSelectsOfView(view));

            view.$('.order-selector .dropdown-menu li a').each(function(index,el){
                var $el = $(el);
                $el.attr('data-service-label',app.t($el.is('.lunch') ? 'Service du midi':'Service du soir','Cart'));
            });

            view.delegateEvents();

        },
        renderDeliveryOptions:function(){
            view.$('.reorder-delivery-options').html(
                reorderDeliveryOptions({cart:virtualCart,store:virtualCart.getStore()})
            );
        },
        authentificationSuccess:function(){
            view.setup();
        },
        openDateTimeSelector:function(){
            var dateTimeSelector = new DateTimeSelectorView({cart:virtualCart});
            app.displayModal(dateTimeSelector);
        },
        openAddressAutocomplete:function(){
            var addressAutocomplete = new AddressAutocompleteView({cart:virtualCart,theme:'modal',autoSubmit:true, type:'all'});
            app.displayModal(addressAutocomplete);
        },
        orderSync:function(){
            //
            // TODO j'utilise la ref du panier courant pour le dev
            // cette ligne peut être enlevée pour tester en condition réelle avec le panier virtuel
            var _DEBUG_WITH_CURRENT_CART_ = false;
            if(_DEBUG_WITH_CURRENT_CART_) {
                view.attachCart(app.getCart());
            }
            //
            view.render();
        },
        setCurrentCart:function(e){
            var view = this,
                submitButton = view.$('.submit-reorder');
            submitButton.addClass('loading');
            TagCommander.tc_ev_gl(e.currentTarget,'eventGA',{
                click_level1:"Mes commandes",
                click_level2:"Repasser commande",
                click_level3:virtualCart.getPriceTTC()
            })
            virtualCart.setCurrent().fail(function(){
                submitButton.removeClass('loading');
            });
        },
        onSetCurrent:function(){
            view.clickClose();
            virtualCart.submitToCheckout();
        },
        onDeliveryUpdate:function(){
            view.renderDeliveryOptions();
        },
        clickClose: function () {
            virtualCart.off();
            virtualCart.clear({silent:true});
            delete virtualCart;
            this.trigger('close', this);
        },

        onAddToCart:function(){
            view.clickClose();
            app.go('listing');
        },
        addtoCart:function(e){
            // update parentOrder with order
            virtualCart.addToCartReorder(parentOrder.get('id_cart'));
        },

        orderChange: function (e) {
            var view = this,
                idOrder = $(e.currentTarget).val(),
                order = ordersList.get(idOrder);

            if (order.isNowService()) {
                if(parentOrder != order){
                    // update parentOrder with order
                    view.$('.reorder-modal').removeClass('reorder-fail');
                    view.$('.order').addClass('change').html('<div class="loader"></div>');
                    view.$('.col.cart').remove();
                    parentOrder = order;
                    virtualCart.reorder(order.get('id_cart'));
                }
            }else{

                app.alert({
                    title:app.t('Attention','UI'),
                    subtitle:app.t(
                        'Vous ne pouvez pas choisir cette commande, car elle appartient au %s',
                        ReorderTranslationContext,
                        app.t(order.isLunchService()?'Service du midi':'Service du soir','Cart').toLowerCase()
                    ),
                },function(){
                      view.$('.order-selector').selectpicker('val',parentOrder.id);
                });
            }

        },
    });

    return ReorderPageView;

});
